import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { RaceSummaryRow } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummary.style';
import {
    CellRunner,
    GreyhoundAndTrainerDetailsBox,
    RaceCardTrap,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/greyhoundRacing/RaceSummaryCastRowGreyhoundRacing.style';

interface PropsType {
    anyCast?: React.ReactNode;
    className?: string;
    dataTest?: string;
    isNonRunner?: boolean;
    isUnnamedFavourite: boolean;
    oneCast?: React.ReactNode;
    place?: React.ReactNode;
    runner?: React.ReactNode;
    selectionId: SelectionId;
    threeCast?: React.ReactNode;
    twoCast?: React.ReactNode;
}

export const RaceSummaryCastRowGreyhoundRacing = observer('RaceSummaryCastRowGreyhoundRacing', (props: PropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const { anyCast, className, dataTest, isNonRunner, isUnnamedFavourite, oneCast, selectionId, threeCast, twoCast } =
        props;

    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const marketModel = selectionModel.getMarket();
    if (marketModel === null) {
        return null;
    }

    if (isUnnamedFavourite === true) {
        return null;
    }

    return (
        <RaceSummaryRow
            className={className}
            isNonRunner={isNonRunner}
            data-test={dataTest}
            variant={configState.componentVariants.sportsbookVariant}
        >
            <CellRunner>
                <RaceCardTrap
                    trapNumber={selectionModel.metaDataNumber}
                    selectionId={selectionId}
                />

                <GreyhoundAndTrainerDetailsBox
                    selectionId={selectionId}
                    isDetailsAvailable={false}
                />
            </CellRunner>

            {oneCast}
            {twoCast}
            {marketModel.tricastsOffered && threeCast}
            {anyCast}
        </RaceSummaryRow>
    );
});
